import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/solid/maps-fill.svg'
import _imports_1 from '@/assets/icons/solid/document-fill.svg'


const _hoisted_1 = { class: "-mt-8" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]

import AttendeesDetailsModal from './AttendeesDetails.vue' // components

	import { // languages
		useI18n
	} from 'vue-i18n'
	
	import { // store
		localesStore
	} from '@/store/locales'

	import { 
		store
	} from '@/store/user'

	import { // vue
		ref
	} from 'vue'

	
	const __default__ = { name: 'AttendeesDetails' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		meeting: {
			type: Object,
			default: () => {return {}}
		},
		loading: {
			type: Boolean,
			default: false
		},
		breadcrumb: {
			type: Array,
			default: () => {return []}
		},
	},
  setup(__props) {

	const props = __props

	const _store = localesStore()
	const userStore = store()

	const {t} = useI18n()

	const openToTab = ref(1)

	const selectedAttendee = ref({})
	const attendeeDetailsModal = ref<{open: boolean}>({open: false})

	function openModalDetail(row: any, tab: number) {
		selectedAttendee.value = row
		openToTab.value = tab
		attendeeDetailsModal.value.open = true	
	}

return (_ctx: any,_cache: any) => {
  const _component_tw_table_column = _resolveComponent("tw-table-column")!
  const _component_CheckIconMini = _resolveComponent("CheckIconMini")!
  const _component_MinusIconMini = _resolveComponent("MinusIconMini")!
  const _component_tw_table = _resolveComponent("tw-table")!
  const _component_tw_modal = _resolveComponent("tw-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_tw_table, {
      placeholder: _unref(t)('placeholders.noAttendees'),
      loading: __props.loading,
      data: __props.meeting?.portalData?.portal_attendees
    }, {
      default: _withCtx(() => [
        _createVNode(_component_tw_table_column, {
          header: _unref(_store).getLabel('408')
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(row["fc_calendar_sample_event__attendee__CONTACTS__contactID::name_display"]), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_tw_table_column, {
          header: _unref(_store).getLabel('102')
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(row["fc_calendar_sample_event__attendee__ROLES__roleID::name_display"]), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_tw_table_column, {
          header: _unref(_store).getLabel('113')
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(row["fc_calendar_sample_event__attendee__contact_employee__POSITIONS__positionID::name_display"]), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        (_unref(userStore).getContactType == 'Staff')
          ? (_openBlock(), _createBlock(_component_tw_table_column, {
              key: 0,
              header: _unref(_store).getLabel('606')
            }, {
              default: _withCtx(({row}) => [
                _createTextVNode(_toDisplayString(row["fc_calendar_sample_event__ATTENDEES__calendarID::pay_type_display"]), 1)
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true),
        (_unref(userStore).getContactType == 'Staff')
          ? (_openBlock(), _createBlock(_component_tw_table_column, {
              key: 1,
              header: _unref(_store).getLabel('324') + ' / ' + _unref(_store).getLabel('410')
            }, {
              default: _withCtx(({row}) => [
                _createTextVNode(_toDisplayString(row["fc_calendar_sample_event__ATTENDEES__calendarID::hourly_rate"] ? '¥' + row["fc_calendar_sample_event__ATTENDEES__calendarID::hourly_rate"] : "-" + (row["fc_calendar_sample_event__ATTENDEES__calendarID::quantity"] ? " /" : " / -") + row["fc_calendar_sample_event__ATTENDEES__calendarID::quantity"]), 1)
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true),
        (_unref(userStore).getContactType == 'Staff')
          ? (_openBlock(), _createBlock(_component_tw_table_column, {
              key: 2,
              header: _unref(_store).getLabel('448')
            }, {
              default: _withCtx(({row}) => [
                _createTextVNode(_toDisplayString(_ctx.$filters.jpy(row["fc_calendar_sample_event__ATTENDEES__calendarID::cost_total"])), 1)
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true),
        _createVNode(_component_tw_table_column, {
          header: _unref(_store).getLabel('196')
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(row["fc_calendar_sample_event__ATTENDEES__calendarID::status_display"]), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_tw_table_column, {
          header: _unref(_store).getLabel('619')
        }, {
          default: _withCtx(({row}) => [
            (row['fc_calendar_sample_event__ATTENDEES__calendarID::meeting_with'])
              ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                  key: 0,
                  class: "h-5 w-5 text-black"
                }))
              : (_openBlock(), _createBlock(_component_MinusIconMini, {
                  key: 1,
                  class: "h-5 w-5 text-gray-300"
                }))
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_tw_table_column, {
          header: _unref(_store).getLabel('292')
        }, {
          default: _withCtx(({row}) => [
            (row['fc_calendar_sample_event__ATTENDEES__calendarID::primary'])
              ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                  key: 0,
                  class: "h-5 w-5 text-black"
                }))
              : (_openBlock(), _createBlock(_component_MinusIconMini, {
                  key: 1,
                  class: "h-5 w-5 text-gray-300"
                }))
          ]),
          _: 1
        }, 8, ["header"]),
        (_unref(userStore).getContactType == 'Staff')
          ? (_openBlock(), _createBlock(_component_tw_table_column, { key: 3 }, {
              default: _withCtx(({row}) => [
                _createElementVNode("div", {
                  class: "h-6 w-6 cursor-pointer",
                  onClick: ($event: any) => (openModalDetail(row, 0))
                }, [
                  _createElementVNode("img", {
                    class: _normalizeClass(row['fc_calendar_sample_event__ATTENDEES__calendarID::description_display'] || row['fc_calendar_sample_event__ATTENDEES__calendarID::emergency_transport'] ? 'linked-icon' : 'grayed-icon'),
                    src: _imports_0,
                    alt: "maps icon"
                  }, null, 2)
                ], 8, _hoisted_2)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_tw_table_column, null, {
          default: _withCtx(({row}) => [
            _createElementVNode("div", {
              class: "h-6 w-6 cursor-pointer",
              onClick: ($event: any) => (openModalDetail(row, _unref(userStore).getContactType == 'Client' ? 0 : 1))
            }, [
              _createElementVNode("img", {
                class: _normalizeClass(row['fc_calendar_sample_event__attendee__DOCUMENTS__attendeeID::_kp_documents_id'] ? 'linked-icon' : 'grayed-icon'),
                src: _imports_1,
                alt: "list icon"
              }, null, 2)
            ], 8, _hoisted_3)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["placeholder", "loading", "data"]),
    _createVNode(_component_tw_modal, {
      title: selectedAttendee.value?.['fc_calendar_sample_event__attendee__CONTACTS__contactID::name_display'],
      breadcrumb: __props.breadcrumb,
      ref_key: "attendeeDetailsModal",
      ref: attendeeDetailsModal
    }, {
      default: _withCtx(() => [
        _createVNode(AttendeesDetailsModal, {
          attendee: selectedAttendee.value,
          "open-to-tab": openToTab.value
        }, null, 8, ["attendee", "open-to-tab"])
      ]),
      _: 1
    }, 8, ["title", "breadcrumb"])
  ]))
}
}

})